import Constructor from '../constructor'
import Map from './module/map'

class Company extends Constructor(Map) {}

export default Company